<template>
  <div class="leea-btn" :class="[{ round, disabled }, color]" :style="{ width }" @click="click">
    <div v-if="completed" class="completed">
      <el-icon>
        <CircleCheck />
      </el-icon>
    </div>
    <div v-else-if="inProgress" class="loading">
      <el-icon>
        <Loading />
      </el-icon>
    </div>
    <slot v-else> </slot>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  color?: string
  round?: boolean
  disabled?: boolean
  width?: string
  inProgress?: boolean
  completed?: boolean
}>()

import { Loading, CircleCheck } from '@element-plus/icons-vue'
const emit = defineEmits(['click'])
const click = () => {
  if (!props.disabled) {
    emit('click')
  }
}
</script>

<style lang="scss" scoped>
.leea-btn {
  padding: 7px 8px 8px 12px;
  background-color: var(--black-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  flex-shrink: 0;

  &.blue {
    background: var(--blue-color);
    color: var(--white-color);
  }

  &.white {
    color: var(--blue-color);
    background: var(--white-color);
  }

  &.round {
    height: 36px;
    padding: 0 15px;
    border-radius: 100px;
  }

  &.disabled {
    background: var(--gray-dark-color);
  }

  .loading {
    padding-top: 4px;

    .el-icon {
      animation: spin 3s infinite linear;
    }
  }

  .completed {
    padding-top: 4px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
